import { IQuestion, IQuestionResponse, TreeItemType } from '@aa/common';

export class TreeQuestionResponse implements IQuestionResponse {
  nextId: Guid;
  nextType: TreeItemType;
  text: string;
  href: string;

  inline: boolean;
  inlineResponseText: string;

  responseHref: string;
  hidden: boolean;

  constructor(q: IQuestionResponse) {
    this.nextType = q.nextType;
    this.nextId = q.nextId;
    this.text = q.text;
    this.href = q.href;

    this.hidden = false;
    this.responseHref = null;
  }
}

export class TreeQuestion implements IQuestion {

  public selectedIndex: Number;
  public selectedResponse: IQuestionResponse;

  public id: Guid;
  public readonly slug: string;
  public readonly text: string;
  public readonly name: string;
  public readonly info: string;
  public readonly relatedQuestionId?: Guid;
  public readonly responses: TreeQuestionResponse[];

  questionHref: string;

  noHighlight: boolean = false;
  showInfo: boolean;

  constructor(q: IQuestion) {
    this.id = q.id;
    this.slug = q.slug;
    this.text = q.text;
    this.name = q.name;
    this.info = q.info;
    this.relatedQuestionId = q.relatedQuestionId;
    this.responses = q.responses.map(o => new TreeQuestionResponse(o));
    this.setSelectedIndex(-1);

    // hide info if response list contains a "More Info" button
    this.showInfo = this.info && !this.responses.some(o => o.nextType === TreeItemType.MoreInfo);
  }

  get hasSelectedIndex(): boolean {
    return this.selectedIndex >= 0;
  }

  isValidIndex(index: number): boolean {
    return index >= 0 && index < this.responses.length;
  }

  setSelectedIndex(index: number): boolean {
    if (!this.isValidIndex(index)) {
      this.selectedIndex = -1;
      this.selectedResponse = null;
      return false;
    }

    this.selectedIndex = index;
    this.selectedResponse = this.responses[index];
    return true;
  }

  public clearSelectedIndex() {
    this.setSelectedIndex(-1);
  }
}
